import zh_CN from './translations/zh-cn.json'
import en from './translations/en-us.json'
import zh_TW from './translations/zh-tw.json'
import de from './translations/de.json'
import fr from './translations/fr.json'
import ru from './translations/ru.json'
import pt from './translations/pt.json'
import es from './translations/es.json'

const resources = {
    zh_CN: { translation: zh_CN },
    zh_TW: { translation: zh_TW },
    en: { translation: en },
    de: { translation: de },
    fr: { translation: fr },
    ru: { translation: ru },
    pt: { translation: pt },
    es: { translation: es },
}

export default resources;